import { FC } from "react";
import { ContentWrapper } from "./styles";
import Typography from "../../../components/typography";

interface Props {
  description: string;
}

const Content: FC<Props> = ({ description }) => {
  return (
    <ContentWrapper>
      <Typography
        as='div'
        fSize={1.063}
        lHeight={1.688}
        fWeight={400}
        margin={{ md: '5 0', xxs: '3 0' }}
        dangerouslySetInnerHTML={{ __html: description.replace(/<p><\/p>/g, '<p>&nbsp;</p>') }}
      />
    </ContentWrapper>
  );
};

export default Content;
